<template>
  <div>
    <v-container grid-list-xl>
      <v-layout row wrap justify-center v-if="isAlreadyLoaded && promotions.length > 0">
        <v-flex xs12 sm6 md4 xl3 v-for="promotion in promotions" :key="promotion.id">
          <EurCardSupport
            :promotion="promotion.promotion"
            :showRebateColumn="false"
            :showRebateDetails="false"
            :showSubmissionDeadline="false"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="isAlreadyLoaded && promotions.length == 0">
        <div class="white--text text-center">
          <p class="mb-5"></p>
          <h1>{{ noPromotionsMessage }}</h1>
          <GoogleReCaptcha :showLegend="false"></GoogleReCaptcha>
          <p class="mb-5"></p>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import GoogleReCaptcha from "@/gapp-components/components/display/GoogleReCaptcha.vue";
import EurCardSupport from "@/views/eur/EurCardSupport.vue";
import Vue from "vue";

import { mapGetters } from "vuex";

export default {
  name: "EurListServiceAndSupport",
  metaInfo() {
    return {
      title: this.$i18n.translate("List of End User of Bravia")
    };
  },
  components: {
    EurCardSupport,
    GoogleReCaptcha
  },
  data() {
    return {
      env: null,
      isLoading: false,
      isAlreadyLoaded: false,
      noPromotionsMessage: this.$i18n.translate("Check back with us soon for new promotions!"),
      promotions: [],
      headers: [
        {
          value: "product.productKey",
          text: "Model",
          sortable: false
        },
        {
          value: "product.name",
          text: "Product",
          sortable: false
        }
      ],
      expandedProducts: []
    };
  },
  watch: {
    selectedCountry() {
      this.getData();
      setTimeout(() => {
        this.noPromotionsMessage = this.$i18n.translate("Check back with us soon for new promotions!");
      }, 300);
    },
    selectedLocale() {
      setTimeout(() => {
        this.noPromotionsMessage = this.$i18n.translate("Check back with us soon for new promotions!");
      }, 300);
    }
  },
  methods: {
    getData() {
      this.isLoading = true;
      let filters = {
        program: { id: this.selectedProgram.id },
        country: this.selectedCountry ? { name: this.selectedCountry.name } : { name: "USA" },
        isSubmissionsEffective: true,
        customFieldValue1: "Service & Support",
        valid: true
      };

      this.$api
        .post("/api/promotions/search/eligible/public?size=100", filters)
        .then(({ data }) => {
          this.promotions = data.content;
          this.promotions.reduce(
            (p, promotion) => this.getUploads(promotion.promotion, promotion.uploads),
            Promise.resolve()
          );
          this.addProductRegistration();
          this.isAlreadyLoaded = true;
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    addProductRegistration() {
      this.promotions.push({
        promotion: {
          name: "Product Registration",
          description:
            "By registering, you'll receive information regarding new firmware upgrades, product trade-in programs and general information to help you get the most out of your new gear.",
          promotionType: { claimable: true },
          banner: { href: require("@/assets/product-registration.png") }
        }
      });
    },

    getUploads(promotion, uploads) {
      Vue.set(promotion, "uploads", uploads);
      uploads.forEach(upload => {
        if (upload.contentType.startsWith("image")) {
          Vue.set(promotion, "banner", upload);
        } else if (upload.contentType.startsWith("application")) {
          Vue.set(promotion, "download", upload);
        }
      });
    },

    getProducts(promotion) {
      if (promotion.id in this.expandedProducts) {
        return;
      }
      this.isLoading = true;
      return this.$api
        .get("/api/promotions/" + promotion.id + "/public")
        .then(({ data }) => {
          this.expandedProducts[promotion.id] = data.promotionProducts;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    this.env = process.env;
  },
  mounted() {
    this.getData();
    this.headers = this.headers.forEach(h => {
      h.text = this.$i18n.translate(h.text);
    });
  },
  computed: {
    ...mapGetters(["selectedProgram", "selectedLocale", "selectedCountry"])
  }
};
</script>
